import React, { useMemo } from "react";
import { Control, FieldValues } from "react-hook-form";

import { PurchaseDate } from "@covertree/new-business-graphql";
import { FormSelectField } from "@covertree/ui";

const PURCHASE_DATE_BASE_OPTIONS = [
  { label: "1-7 days ago", value: PurchaseDate.Between1_7 },
  { label: "8-30 days ago", value: PurchaseDate.Between8_30 },
  { label: "31-90 days ago", value: PurchaseDate.Between31_90 },
  {
    label: "More than 90 days ago",
    value: PurchaseDate.MoreThan90,
  },
] as const;

const getPurchaseDateOptions = (isD2C: boolean) => [
  {
    label: isD2C
      ? "I am currently in the buying process or awaiting delivery"
      : "Applicant is currently in the buying process or awaiting delivery",
    value: PurchaseDate.CurrentlyInTheBuyingProcess,
  },
  ...PURCHASE_DATE_BASE_OPTIONS,
];

export const purchaseDateValues = getPurchaseDateOptions(true).map(
  (option) => option.value
);

interface Props<TValues extends FieldValues> {
  control: Control<TValues>;
  name?: string;
  label?: string;
  placeholder?: string;
  isD2C?: boolean;
}

export const PurchaseDateSelect = <TValues extends FieldValues>({
  control,
  name = "homePurchaseTimeline",
  label,
  placeholder = "Select...",
  isD2C = true,
}: Props<TValues>) => {
  const options = useMemo(() => getPurchaseDateOptions(isD2C), [isD2C]);

  const defaultLabel = isD2C
    ? "When did you take ownership of the home?"
    : "When did applicant take ownership of the home?";

  return (
    <FormSelectField
      control={control}
      id="purchase-date"
      dataTestId="purchase-date-field"
      options={options}
      name={name}
      label={label ?? defaultLabel}
      placeholder={placeholder}
    />
  );
};
